import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../lib/api";

const DEFAULT = { appLogo: null, companyName: "Central Flow" };
const BrandingCtx = createContext({ ...DEFAULT, refresh: () => {} });

function applyFavicon(href) {
  if (!href) return;
  let link = document.querySelector("link[rel='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = href;
}

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULT);

  const refresh = useCallback(() => {
    api.get("/branding").then(({ data }) => {
      const next = { appLogo: data.app_logo || null, companyName: data.company_name || "Central Flow" };
      setBranding(next);
      applyFavicon(next.appLogo);
    }).catch(() => {});
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <BrandingCtx.Provider value={{ ...branding, refresh }}>{children}</BrandingCtx.Provider>;
}

export const useBranding = () => useContext(BrandingCtx);
